<template>
  <div class="flex w-full" style="position: relative">
    <div v-if="gliders.length" class="d-flex flex-col w-full h-full">
      <v-tabs v-if="showTabs" v-model="selectedGliderIdx" align-with-title class="flex-grow-0">
        <v-tab v-for="(glider, idx) in gliders" :key="glider.id" :title="glider.libelle">
          {{ glider.libelle }}
        </v-tab>
      </v-tabs>
      <mission-detail-console
        :readonly="
          props.fleet.activeMissionIds.every(
            misId => misId != store.myGetters.missionsById[gliders[selectedGliderIdx].id].misId,
          )
        "
        :uiid="uiid"
        :isleft="isleft"
        :mission="store.myGetters.missionsById[gliders[selectedGliderIdx].id]"
        :isVisible="props.isVisible"
        :key="selectedGliderIdx"
      />
    </div>
    <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2">
      <span>{{ $t('Fleet.NoGliders') }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import MissionDetailConsole from '@/components/mission/MissionDetailConsole.vue'

const props = defineProps<{
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
}>()

const missions = computed(
  () =>
    props.fleet.param?.missionIds
      ?.map(id => store.myGetters?.missionsById[id])
      ?.filter(m => !!m)
      ?.sort((m, m1) =>
        !props.fleet.activeMissionIds.includes(m.misId!)
          ? 1
          : !props.fleet.activeMissionIds.includes(m1.misId!)
          ? -1
          : props.fleet.activeMissionIds.findIndex(misId => m.misId == misId) -
            props.fleet.activeMissionIds.findIndex(misId => m1.misId == misId),
      ) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

const showTabs = ref(true)
onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})
</script>
